import { z } from "zod";
import type { infer as zInfer } from "zod";

export const withdrawalSettings = z.object({
  amountToTurnover: z.number(),
});

export type WithdrawalSettings = zInfer<typeof withdrawalSettings>;
